module.exports = __webpack_public_path__ + "assets/d3994db792db0018d5abd6481136489c.mp3";